const textModule = {
  id: "b5884573-0c5f-31de-94e3-be1048c70f59",
  component: "CRText",
  config: {
    general: {
      blockWidth: {
        label: "2/3",
        value: "twoThirds",
      },
      template: {
        label: "Center",
        component: "TextCenterMiddle",
      },
      paddings: {
        top: true,
        bottom: true,
      },
      backgroundColor: {
        label: "White",
        value: "#ffffff",
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        mediaType: "image",
      },
      showMedia: true,
      showText: false,
      showHeader: true,
    },
    header: {
      text: "Be yourself & more.",
      isTextInCaps: false,
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
    text: {
      text: "We’re change agents and cyber gurus. Performance improvers and problem solvers. Data scientists and growth hackers. Bot programmers and software builders. Risk managers and confidence builders. We’re more than 365,000 global perspectives ready to welcome yours.",
      textColor: {
        label: "Black",
        value: "#000000",
      },
    },
  },
};

export default textModule;
